import { Table } from "antd";
import React, { FC } from "react";

const columns = [
  {
    title: "№",
    dataIndex: "key",
  },
  {
    title: "Показатель",
    dataIndex: "title",
    width: "60%",
  },
  {
    title: "Значение",
    dataIndex: "value",
    width: "30%",
  },
];

interface IRatingTable {
  dataSource: {
    key: string;
    title: string;
    value: number | string;
  }[];
}

export const RatingTable: FC<IRatingTable> = (props) => {
  const { dataSource } = props;

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      bordered
      pagination={false}
    />
  );
};
